module.exports = __webpack_public_path__ + "static/media/photo-2.cca3f35d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/hall-farm-threshing-barn/photo-2.jpg
// module id = 161
// module chunks = 0